import {
    DateAfterModification,
    ManagementPolicyRule,
} from "store/storage-accounts/storage-accounts-types";

import i18n from "utils/i18n";

export const tierDescriptions: Record<string, string> = {
    tierToCool: i18n.t("storageAccounts.ruleDescriptions.cool"),
    tierToCold: i18n.t("storageAccounts.ruleDescriptions.cold"),
    tierToArchive: i18n.t("storageAccounts.ruleDescriptions.archive"),
    delete: i18n.t("storageAccounts.ruleDescriptions.delete"),
};

export const ruleNames: Record<string, string> = {
    cool: "Cool",
    cold: "Cold",
    archive: "Archive",
    delete: "Delete",
};

export const getAppliedRuleValue = (
    rules: ReadonlyArray<ManagementPolicyRule>,
    ruleName: string
): string | number => {
    const rule = rules.find((r) => r.name === ruleName);
    if (rule === undefined) {
        return i18n.t("unknown");
    }

    const tier: DateAfterModification = Object.values(
        rule.definition.actions.baseBlob
    ).find((b) => b !== null && (b as DateAfterModification));

    return tier.daysAfterModificationGreaterThan ?? i18n.t("unknown");
};
